module.exports = __webpack_public_path__ + "img/glass_demonstration.885fca92.jpg";